export default __webpack_public_path__ + "static/media/green-check.f34bdf9d.svg";